import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Checkbox, Button } from "react-bootstrap";
import Message from "./message";
import ConfirmPopup from "../common/confirm-popup";
import {
  markMessagesAs,
  deleteMessages,
  deleteMessage,
} from "../../actions/messages";

class MessagesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: [],
      opened: [],
      delete: {
        show: false,
      },
    };
  }

  onReadClicked = () => {
    this.props
      .dispatch(markMessagesAs("read", this.state.checked))
      .then(() => this.setState({ checked: [] }));
  };

  onUnreadClicked = () => {
    this.props
      .dispatch(markMessagesAs("unread", this.state.checked))
      .then(() => {
        this.setState({ checked: [], opened: [] });
      });
  };

  onDeleteClicked = () => {
    this.setState({ delete: { show: true } });
  };

  onMessageOpened = (id, status, read) => {
    if (status && !read) {
      this.props.dispatch(markMessagesAs("read", [id]));
    }

    let opened = [...this.state.opened];

    if (status) {
      opened.push(id);
    } else {
      opened = this.state.opened.filter((item) => item !== id);
    }

    this.setState({ opened: opened });
  };

  onMessageChecked = (id, status) => {
    let checked = [...this.state.checked];

    if (status) {
      checked.push(id);
    } else {
      checked = this.state.checked.filter((item) => item !== id);
    }

    this.setState({ checked: checked });
  };

  onDeleteMessage = (id) => {
    this.setState({ delete: { show: true, id: id } });
  };

  handleDelete = (result) => {
    const { id } = this.state.delete;

    if (result) {
      if (id) {
        this.props.dispatch(deleteMessage(id)).then(() =>
          this.setState({
            checked: this.state.checked.filter((checked) => checked !== id),
            delete: { show: false },
          })
        );
      } else {
        this.props.dispatch(deleteMessages(this.state.checked)).then(() =>
          this.setState({
            checked: [],
            delete: { show: false },
          })
        );
      }
    } else {
      this.setState({ delete: { show: false } });
    }
  };

  render() {
    let rows = [];
    let numOfColumns = 4;

    for (let i = 0, l = this.props.messages.length; i < l; i += numOfColumns) {
      let messages = this.props.messages
        .slice(i, i + numOfColumns)
        .map((message) => (
          <Message
            key={`${message.id}-${message.attributes.read}`}
            message={message}
            checked={!!this.state.checked.find((item) => item === message.id)}
            opened={!!this.state.opened.find((item) => item === message.id)}
            onMessageOpened={this.onMessageOpened}
            onMessageChecked={this.onMessageChecked}
            onDelete={this.onDeleteMessage}
          />
        ));
      rows.push(<Row key={`${i}-${i + numOfColumns}`}>{messages}</Row>);
    }

    return (
      <div>
        <Row>
          <Col>
            <span className="messages-filter">
              <Checkbox
                inline
                defaultChecked={this.props.showRead}
                onChange={(e) =>
                  this.props.onFilterChanged("showRead", e.target.checked)
                }
              >
                <span className="check-mark"></span>
                <i className="fa fa-envelope-open-o" />
               <span className="text-filter">Read messages</span> 
              </Checkbox>
            </span>
            <span className="messages-filter">
              <Checkbox
                inline
                defaultChecked={this.props.showUnread}
                onChange={(e) =>
                  this.props.onFilterChanged("showUnread", e.target.checked)
                }
              >
                 <span className="check-mark"></span>
                <i className="fa fa-envelope-o" />
                <span className="text-filter">Unread messages</span>
              </Checkbox>
            </span>
            <span className="messages-delete">
              <Button
                bsStyle="link"
                onClick={this.onDeleteClicked}
                disabled={!this.state.checked.length}
              >
                <i className="fa fa-trash" />
              </Button>
            </span>
          </Col>
        </Row>
        <div className="messages-list">
          {rows}
          {this.state.delete.show && (
            <ConfirmPopup header="Delete message?" onClose={this.handleDelete}>
              <p>Are you sure you want to delete the selected message(s)?</p>
            </ConfirmPopup>
          )}
        </div>
      </div>
    );
  }
}

export default connect()(MessagesList);



// WEBPACK FOOTER //
// ./src/components/my-messages/messages-list.jsx